import React from 'react';
import ReactModal from 'react-modal';
import { noop } from 'lodash';

import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

// DEPRECATED: use src/components/dialog/ConfirmationDialog.component.jsx

// eslint-disable-next-line react/prefer-stateless-function
class ConfirmationDialog extends React.Component {
  static defaultProps = {
    children: [],
    onLeft: noop,
    onRight: noop,
    onCancel: noop,
    noClose: false,
  };

  render() {
    // stops the modal component from complaining in browser's console
    // noinspection JSUnresolvedFunction
    ReactModal.setAppElement('body');

    const { title, leftButtonText, onLeft, rightButtonText, onRight, onCancel, tag: tagFromProps, disabledRight, disabledLeft } = this.props;
    const { footerText, displayHeader, children, noClose } = this.props;
    const tag = fromAnyToTrimmed(tagFromProps);

    return (
      <ReactModal
        onRequestClose={onCancel}
        closeTimeoutMS={0}
        contentLabel={title}
        isOpen
        ariaHideApp
        animation={false}
        shouldCloseOnOverlayClick
        role="dialog"
        style={{ overlay: { zIndex: 10000001 } }}
        className={{ base: 'dialog-container', afterOpen: 'dialog-container', beforeClose: 'dialog-container' }}
      >
        <div data-bem="ConfirmationDialog--scheduler" data-modal-tag={tag} data-dialog-body="ConfirmationDialog" className={`dialog ${fromAnyToTrimmed(displayHeader)}`}>
          <div data-modal-tag={tag} className="dialog-header">
            <h2 data-modal-tag={tag}>{title}</h2>
            {!noClose && <div data-modal-tag={tag} className="close" role="button" tabIndex={0} onClick={onCancel} />}
          </div>
          <div data-modal-tag={tag} className="body">
            {children}
          </div>
          <div data-modal-tag={tag} className="dialog-footer cfix">
            <span data-modal-tag={tag} className="warning-text">
              {fromAnyToTrimmed(footerText)}
            </span>
            <button
              data-modal-tag={tag}
              data-cy="confirm-left-button"
              data-bem="ConfirmationDialog__button-left--scheduler"
              className="btn btn-white"
              tabIndex={0}
              onClick={onLeft}
              disabled={disabledLeft}
            >
              {leftButtonText}
            </button>
            <button data-bem="ConfirmationDialog__button-right--scheduler" data-modal-tag={tag} className="btn btn-violet" tabIndex={0} onClick={onRight} disabled={disabledRight}>
              {rightButtonText}
            </button>
          </div>
        </div>
      </ReactModal>
    );
  }
}

export default ConfirmationDialog;
